import React from "react";
import { Canvas } from "@react-three/fiber";
import {
  Html,
  OrbitControls,
  PivotControls,
  Environment,
} from "@react-three/drei";
import * as THREE from "three";

type Props = {
  /** When true, shows PivotControls; when false, hides them */
  editing?: boolean;
  /** Optional callbacks for the Html buttons */
  onPrimary?: () => void;
  onSecondary?: () => void;
  handleSceneChosen?: (scene: number) => void;
};

export default function WelcomeScreen({
  editing = false,
  onPrimary,
  onSecondary,
  handleSceneChosen,
}: Props) {
  // refs to the outer group (ground) and the Html wrapper so we can orient them
  const groundRef = React.useRef<THREE.Group | null>(null);
  const htmlWrapperRef = React.useRef<THREE.Group | null>(null);

  React.useEffect(() => {
    const target = new THREE.Vector3(0, 0, 0);
    if (groundRef.current) groundRef.current.lookAt(target);
    if (htmlWrapperRef.current) htmlWrapperRef.current.lookAt(target);
  }, []);

  return (
    <group ref={groundRef} position={[-3, -0.9, -4]} scale={1}>
      {/* Html UI card floating above the box */}
      <group ref={htmlWrapperRef}>
        <Html
          transform
          position={[0, 0, 0]} // float above the box
          rotation={[-0.4, 0, -0.01]} // slight backward tilt (~10°)
          distanceFactor={4} // scale with camera distance
          occlude // hide when obstructed
          pointerEvents="auto" // allow button clicks
          zIndexRange={[1, 2]}
        >
          <div
            style={{
              width: 220,
              height: 300,
              padding: "14px 16px",
              borderRadius: 16,
              background: "rgba(255, 255, 255)",
            }}
          >
            <div
              style={{
                fontSize: 16,
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: 10,
                letterSpacing: 0.2,
              }}
            >
              Choose a Sector to get started
            </div>

            <div style={{ display: "grid", gap: 8 }}>
              <button
                onClick={() => handleSceneChosen && handleSceneChosen(1)}
                style={{
                  height: 36,
                  borderRadius: 10,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  background: "#00569c",
                  color: "white",
                  boxShadow: "0 6px 14px rgba(37,99,235,0.35)",
                }}
              >
                Pharmacy
              </button>
              <button
                onClick={() => handleSceneChosen && handleSceneChosen(2)}
                style={{
                  height: 36,
                  borderRadius: 10,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  background: "#00569c",
                  color: "white",
                  boxShadow: "0 6px 14px rgba(37,99,235,0.35)",
                }}
              >
                Ward
              </button>
              {/* <button
                onClick={onPrimary}
                style={{
                  height: 36,
                  borderRadius: 10,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  background: "#00569c",
                  color: "white",
                  boxShadow: "0 6px 14px rgba(37,99,235,0.35)",
                }}
              >
                Other
              </button> */}
            </div>
          </div>
        </Html>
      </group>
    </group>
  );
}
